import axios from "./axios-auth";

const getDefaultSystemRoles = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientroles",
      params: payload.params,
      data: payload.body,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from emailPassword");
      });
  });

const getCustomSystemRoles = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientroles",
      params: payload.params,
      data: payload.body,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from emailPassword");
      });
  });

const getClientRoleModules = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientrolemodules",
      params: payload,
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from emailPassword");
      });
  });

const getClientRolesByClientId = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientrolemodules",
      params: payload,
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from getClientRolesByClientId api");
      });
  });

const insertCustomClientRoles = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/addcustomclientrole",
      data: payload,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from insertCustomClientRoles api");
      });
  });

const getAllModules = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getallmodules",
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from getAllModules api");
      });
  });

const removeClientRoleByClientId = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/deletecustomclientrolebyclientroleid",
      params: payload,
      method: "DELETE",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from getAllModules api");
      });
  });

const getClientUsers = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientusers",
      data: payload,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from getClientUsers");
      });
  });

const getClientUsersHistory = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientusershistory",
      params: payload.params,
      data: payload.data,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from getClientUsersHistory");
      });
  });

const getClientUserRoles = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientuserroles",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from getClientUserRoles");
      });
  });

const updateClientUserUnit = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/updateclientuserunit",
      data: payload,
      method: "PUT",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from updateClientUserUnit");
      });
  });

const editRolesForModules = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/updateclientmodulebyclientid",
      data: payload,
      method: "PUT",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from editRolesForModules");
      });
  });

const getAllSystemRoles = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getclientroles",
      data: payload.data,
      params: payload.params,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from getAllSystemRoles");
      });
  });

const updateCustomClientRoles = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/updatecustomclientrole",
      data: payload,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      })
      .catch(() => {
        console.log("error from updateCustomClientRoles");
      });
  });

export {
  getDefaultSystemRoles,
  getCustomSystemRoles,
  getClientRoleModules,
  getClientRolesByClientId,
  insertCustomClientRoles,
  getAllModules,
  removeClientRoleByClientId,
  getClientUsers,
  getClientUsersHistory,
  getClientUserRoles,
  updateClientUserUnit,
  editRolesForModules,
  getAllSystemRoles,
  updateCustomClientRoles,
};
